"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var iCheck = 'iCheck';
var iCheckHelper = "".concat(iCheck, "-helper");

var Input =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Input, _Component);

  function Input(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Input);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Input).call(this, props));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.handleHelperClick = _this.handleHelperClick.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    var checked = props.checked,
        defaultChecked = props.defaultChecked,
        hovered = props.hovered,
        indeterminate = props.indeterminate;
    _this.state = {
      active: false,
      checked: defaultChecked || checked,
      focused: false,
      hovered: hovered,
      indeterminate: indeterminate
    };
    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          prevChecked = _this$props.checked,
          prevHovered = _this$props.hovered;
      var checked = nextProps.checked,
          hovered = nextProps.hovered;

      if (checked !== prevChecked) {
        this.setState({
          checked: checked
        });
      }

      if (hovered !== prevHovered) {
        this.setState({
          hovered: hovered
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;
      this.setState({
        focused: false
      });

      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;
      var checked = event.target.checked;
      this.setState(function (state) {
        return {
          checked: !state.checked
        };
      });

      if (onChange) {
        onChange(event, checked);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;
      this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: "handleHelperClick",
    value: function handleHelperClick(event) {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          inputType = _this$props2.inputType,
          insert = _this$props2.insert,
          label = _this$props2.label,
          onChange = _this$props2.onChange;
      var checked = this.state.checked;

      if (!label && !insert || disabled) {
        return;
      }

      if (inputType === 'checkbox') {
        this.setState(function (state) {
          return {
            checked: !state.checked
          };
        });
      }

      event.preventDefault();
      event.stopPropagation();

      if (onChange) {
        // make sure <ins /> element is not target
        event.target = this.checkbox; // eslint-disable-line no-param-reassign

        onChange(event, checked);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props3 = this.props,
          activeClass = _this$props3.activeClass,
          aria = _this$props3.aria,
          checkboxClass = _this$props3.checkboxClass,
          checkedClass = _this$props3.checkedClass,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          disabledClass = _this$props3.disabledClass,
          focusClass = _this$props3.focusClass,
          hoverClass = _this$props3.hoverClass,
          id = _this$props3.id,
          increaseArea = _this$props3.increaseArea,
          indeterminateClass = _this$props3.indeterminateClass,
          inheritClass = _this$props3.inheritClass,
          inheritID = _this$props3.inheritID,
          inputType = _this$props3.inputType,
          insert = _this$props3.insert,
          isMobile = _this$props3.isMobile,
          name = _this$props3.name,
          radioClass = _this$props3.radioClass,
          value = _this$props3.value,
          defaultChecked = _this$props3.defaultChecked,
          hovered = _this$props3.hovered,
          indeterminate = _this$props3.indeterminate,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["activeClass", "aria", "checkboxClass", "checkedClass", "className", "disabled", "disabledClass", "focusClass", "hoverClass", "id", "increaseArea", "indeterminateClass", "inheritClass", "inheritID", "inputType", "insert", "isMobile", "name", "radioClass", "value", "defaultChecked", "hovered", "indeterminate"]);
      var _this$state = this.state,
          active = _this$state.active,
          checked = _this$state.checked,
          focused = _this$state.focused,
          stateHovered = _this$state.hovered,
          stateIndeterminate = _this$state.indeterminate;
      var wrapProps = {
        className: (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, checkboxClass, inputType === 'checkbox'), (0, _defineProperty2.default)(_classNames, radioClass, inputType === 'radio'), (0, _defineProperty2.default)(_classNames, indeterminateClass, stateIndeterminate), (0, _defineProperty2.default)(_classNames, checkedClass, checked), (0, _defineProperty2.default)(_classNames, disabledClass, disabled), (0, _defineProperty2.default)(_classNames, hoverClass, stateHovered), (0, _defineProperty2.default)(_classNames, focusClass, focused), (0, _defineProperty2.default)(_classNames, activeClass, active), _classNames))
      };

      if (inheritClass) {
        wrapProps.className = (0, _classnames.default)(wrapProps.className, className);
      }

      if (inheritID && id) {
        wrapProps.id = "".concat(iCheck, "-").concat(id);
      }

      if (aria) {
        wrapProps.role = inputType; // Set ARIA "labelledby"

        wrapProps['aria-labelledby'] = wrapProps.id;
        wrapProps['aria-checked'] = checked;
      } // Clickable area


      var area = "".concat(increaseArea).replace('%', '') || 0;

      if (area < -50) {
        area = -50;
      } // Layer styles


      var offset = "".concat(-area, "%");
      var size = "".concat(100 + area * 2, "%");
      var layer = {
        position: 'absolute',
        top: offset,
        left: offset,
        display: 'block',
        width: size,
        height: size,
        margin: 0,
        padding: 0,
        background: '#fff',
        border: 0,
        opacity: 0,
        cursor: disabled ? 'default' : 'pointer'
      }; // Layer addition

      var helper = _react.default.createElement("ins", {
        className: iCheckHelper,
        role: "presentation",
        style: layer,
        onClick: this.handleHelperClick
      }); // Choose how to hide input


      var hide;

      if (isMobile) {
        hide = {
          position: 'absolute',
          visibility: 'hidden'
        };
      } else if (area) {
        hide = layer;
      } else {
        hide = {
          opacity: 0,
          position: 'absolute'
        };
      }

      var inputElement = _react.default.createElement("input", (0, _extends2.default)({}, other, {
        checked: checked,
        disabled: disabled,
        name: name,
        ref: function ref(c) {
          _this2.checkbox = c;
        },
        style: hide,
        type: inputType,
        value: value,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus
      }));

      var insertElement = null;

      if (insert) {
        insertElement = _react.default.isValidElement(insert) ? insert : // eslint-disable-next-line react/no-danger
        _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: insert
          }
        });
      }

      return _react.default.createElement("div", wrapProps, inputElement, insertElement, helper);
    }
  }]);
  return Input;
}(_react.Component);

(0, _defineProperty2.default)(Input, "propTypes", {
  inputType: _propTypes.default.string.isRequired,
  activeClass: _propTypes.default.string,
  aria: _propTypes.default.bool,
  checkboxClass: _propTypes.default.string,
  checked: _propTypes.default.bool,
  checkedClass: _propTypes.default.string,
  className: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  disabledClass: _propTypes.default.string,
  focusClass: _propTypes.default.string,
  hoverClass: _propTypes.default.string,
  hovered: _propTypes.default.bool,
  id: _propTypes.default.string,
  increaseArea: _propTypes.default.string,
  indeterminate: _propTypes.default.bool,
  indeterminateClass: _propTypes.default.string,
  inheritClass: _propTypes.default.bool,
  inheritID: _propTypes.default.bool,
  insert: _propTypes.default.node,
  isMobile: _propTypes.default.bool,
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  radioClass: _propTypes.default.string,
  value: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func
});
(0, _defineProperty2.default)(Input, "defaultProps", {
  activeClass: null,
  aria: false,
  checkboxClass: 'icheckbox',
  checked: false,
  checkedClass: 'checked',
  className: null,
  defaultChecked: false,
  disabled: false,
  disabledClass: 'disabled',
  focusClass: 'focus',
  hoverClass: 'hover',
  hovered: false,
  id: null,
  increaseArea: '',
  indeterminate: false,
  indeterminateClass: 'indeterminate',
  inheritClass: false,
  inheritID: false,
  insert: null,
  isMobile: false,
  label: null,
  name: null,
  radioClass: 'iradio',
  value: '',
  onBlur: null,
  onChange: null,
  onFocus: null
});
var _default = Input;
exports.default = _default;